"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getYearsPeriod = getYearsPeriod;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ArrowRight = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowRight16"));
var _ArrowLeft = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLeft16"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _excluded = ["date", "decrease", "onDecreaseClick", "increase", "onIncreaseClick", "viewType", "setViewType"];
var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
// copied these functions from react-datepicker repo
function getYear(date) {
  return date.getFullYear();
}
function getYearsPeriod(date) {
  var yearItemNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
  var endPeriod = Math.ceil(getYear(date) / yearItemNumber) * yearItemNumber;
  var startPeriod = endPeriod - (yearItemNumber - 1);
  return {
    startPeriod: startPeriod,
    endPeriod: endPeriod
  };
}
function headerText(viewType, date) {
  switch (viewType) {
    case 'day':
      return "".concat(MONTHS[date.getMonth()], " ").concat(date.getFullYear());
    case 'month':
      return "".concat(date.getFullYear());
    case 'year':
      var _getYearsPeriod = getYearsPeriod(date),
        startPeriod = _getYearsPeriod.startPeriod,
        endPeriod = _getYearsPeriod.endPeriod;
      return "".concat(startPeriod, " - ").concat(endPeriod);
  }
}
var CustomHeader = function CustomHeader(_ref) {
  var date = _ref.date,
    decrease = _ref.decrease,
    onDecreaseClick = _ref.onDecreaseClick,
    increase = _ref.increase,
    onIncreaseClick = _ref.onIncreaseClick,
    _ref$viewType = _ref.viewType,
    viewType = _ref$viewType === void 0 ? 'day' : _ref$viewType,
    setViewType = _ref.setViewType,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var decreaseCallback = function decreaseCallback() {
    decrease();
    if (onDecreaseClick) {
      onDecreaseClick(date, 'decrease');
    }
  };
  var increaseCallback = function increaseCallback() {
    increase();
    if (onIncreaseClick) {
      onIncreaseClick(date, 'increase');
    }
  };
  var prevDisabled = viewType === 'day' ? rest.prevMonthButtonDisabled : rest.prevYearButtonDisabled;
  var nextDisabled = viewType === 'day' ? rest.nextMonthButtonDisabled : rest.nextYearButtonDisabled;
  var changeDatePickerType = function changeDatePickerType() {
    if (viewType === 'day') {
      setViewType('month');
    }
    if (viewType === 'month') {
      setViewType('year');
    }
  };
  var isClickable = viewType !== 'year';
  return /*#__PURE__*/_react["default"].createElement(Header, null, /*#__PURE__*/_react["default"].createElement(Prev, {
    icon: _ArrowLeft["default"],
    onClick: decreaseCallback,
    label: viewType === 'day' ? 'Previous Month' : 'Previous Year',
    disabled: prevDisabled,
    testId: "datepicker-prev--button"
  }), isClickable ? /*#__PURE__*/_react["default"].createElement(_HBClickable["default"], {
    onClick: changeDatePickerType,
    testIdName: "datepicker-header"
  }, /*#__PURE__*/_react["default"].createElement(HeaderContent, null, /*#__PURE__*/_react["default"].createElement(HeaderTitle, {
    isClickable: true
  }, headerText(viewType, date)))) : /*#__PURE__*/_react["default"].createElement(HeaderTitle, null, headerText(viewType, date)), /*#__PURE__*/_react["default"].createElement(Next, {
    icon: _ArrowRight["default"],
    onClick: increaseCallback,
    label: viewType === 'day' ? 'Next Month' : 'Next Year',
    disabled: nextDisabled,
    testId: "datepicker-next--button"
  }));
};
var _default = exports["default"] = CustomHeader; // -------------------------------- Styles -------------------------------- //
var Header = _styledComponents["default"].div.withConfig({
  displayName: "CustomHeader__Header",
  componentId: "sc-fcewt-0"
})(["display:flex;align-items:center;justify-content:center;margin-bottom:16px;position:relative;"]);
var HeaderTitle = _styledComponents["default"].span.withConfig({
  displayName: "CustomHeader__HeaderTitle",
  componentId: "sc-fcewt-1"
})(["font-size:14px;font-weight:600;text-transform:uppercase;color:", ";cursor:", ";", ""], _colors["default"].neutral800, function (_ref2) {
  var isClickable = _ref2.isClickable;
  return isClickable ? 'pointer' : 'default';
}, function (_ref3) {
  var isClickable = _ref3.isClickable;
  return isClickable && "\n        &:hover {\n            background-color: ".concat(_colors["default"].neutral100, ";\n            padding: 4px 8px;\n            margin: -4px;\n            border-radius: 2px;\n        }\n    ");
});
var NavButton = (0, _styledComponents["default"])(_HBIconButton["default"]).withConfig({
  displayName: "CustomHeader__NavButton",
  componentId: "sc-fcewt-2"
})(["position:absolute;top:-10px;"]);
var Prev = (0, _styledComponents["default"])(NavButton).withConfig({
  displayName: "CustomHeader__Prev",
  componentId: "sc-fcewt-3"
})(["left:0px;"]);
var Next = (0, _styledComponents["default"])(NavButton).withConfig({
  displayName: "CustomHeader__Next",
  componentId: "sc-fcewt-4"
})(["right:0px;"]);
var HeaderContent = _styledComponents["default"].div.withConfig({
  displayName: "CustomHeader__HeaderContent",
  componentId: "sc-fcewt-5"
})(["display:flex;gap:4px;"]);
//# sourceMappingURL=CustomHeader.js.map